module.exports = __webpack_public_path__ + "img/pay-welfare-btn-bg.3681da72.png";